import React from "react";
import styled, { keyframes } from "styled-components";

const sdb10 = keyframes`
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  80% {
    transform: translate(0, 20px);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`;

const Section = styled.section`
  cursor: pointer;
  background: url() center center/cover no-repeat;
`;

const ScrollButton = styled.a`
  position: fixed;
  left: 96%;
  z-index: 2;
  display: inline-block;
  transform: translate(-50%, -50%);
  color: #fff;
  font: normal 400 20px/1 "Josefin Sans", sans-serif;
  letter-spacing: 0.1em;
  text-decoration: none;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.5;
  }

  span {
    position: fixed;
    top: 90%;
    width: 40px;
    height: 60px;
    margin-left: -15px;
    border: 2px solid #fff;
    border-radius: 50px;
    box-sizing: border-box;
    
    p {
      position: absolute;
      font-size:16px!important;
      left: 50%;
      color:#fff;
      margin-left: -24px;
      top:85%;
      animation: ${sdb10} 2s infinite;
      
    }

    &::before {
      position: absolute;
      top: 15px;
      left: 50%;
      content: "";
      width: 6px;
      height: 9px;
      margin-left: -3px;
      background-color: #fff;
      border-radius: 100%;
      animation: ${sdb10} 2s infinite;
      box-sizing: border-box;
    }
  }

  width: 33px;
  height: 65px;
  bottom:80px;
  right:100px;

  @media screen and (max-width: 700px) {
    bottom:150px;
    top: 85%;
    left: 90%;
  }


`;

const ScrollDownButton = () => {
  const handleScrollClick = () => {
    // Calculate the current vertical scroll position
    const currentScrollY = window.scrollY;

    // Calculate the new vertical scroll position (100 pixels down)
    const newScrollY = currentScrollY + 800;

    // Scroll the page vertically
    window.scrollTo({
      top: newScrollY,
      behavior: "smooth",
    });
  };

  return (
    <Section className="demo">
      <span>scroll</span>
      <ScrollButton onClick={handleScrollClick}>
        <span><p> scroll</p></span>
      </ScrollButton>
    </Section>
  );
};

export default ScrollDownButton;
